module.exports = __webpack_public_path__ + "media/theme/sigzag-5f4e64dc.png";